import { render, staticRenderFns } from "./BigPost.vue?vue&type=template&id=364d24f4&"
import script from "./BigPost.vue?vue&type=script&lang=js&"
export * from "./BigPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports